module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cannotAssignRole":"You may not edit your own Sitewide Role.","field":{"sitewideRole":"Sitewide Role"},"cannotRetire":"You may not retire yourself.","action":{"retire":"Retire user"}}}')
  delete Component.options._Ctor
}
